module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "displayImg",
    staticClass: "display-img",
    class: _vm.className,
    style: (_vm._style_)
  }, [(_vm.isLink) ? _c('ul', {
    key: "link",
    staticClass: "clearfix img_box",
    attrs: {
      "id": "show_img"
    }
  }, _vm._l((_vm.images), function(item) {
    return _c('li', {
      style: (_vm.size)
    }, [_c('router-link', {
      attrs: {
        "to": item.url
      }
    }, [_c('auto-img', {
      attrs: {
        "src": item.imgurl,
        "css": _vm.size
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "img_desc"
    }, [_vm._v(_vm._s(_vm.filter_desc(item.desc)))])], 1)], 1)
  })) : _c('ul', {
    key: "img",
    staticClass: "clearfix img_box",
    attrs: {
      "id": "show_img"
    }
  }, _vm._l((_vm.images), function(item) {
    return _c('li', {
      style: (_vm.size)
    }, [_c('auto-img', {
      attrs: {
        "src": item.imgurl,
        "css": _vm.size
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "img_desc"
    }, [_vm._v(_vm._s(_vm.filter_desc(item.desc)))])], 1)
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._show_ctl),
      expression: "_show_ctl"
    }],
    staticClass: "control",
    attrs: {
      "id": "control_left"
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._show_ctl),
      expression: "_show_ctl"
    }],
    staticClass: "control",
    attrs: {
      "id": "control_right"
    }
  }, [_vm._v(">")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a0fe8f7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/Displayimg.vue
// module id = 186
// module chunks = 1